import React from 'react';
import Loader from 'react-loader-spinner';

const LoaderContainer = () => {
  return (
    <section className="loader-container">
      <Loader type="Oval" color="#5d9af8" height={80} width={80} />
    </section>
  );
};

export default LoaderContainer;